"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParaswapFeed = void 0;
const _ = require("lodash");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const PriceFeedAbi = __importStar(require("./abi/priceFeed.json"));
class ParaswapFeed {
    constructor(network, web3Provider) {
        this.network = network;
        this.web3Provider = web3Provider;
    }
    getRate(srcToken, destToken, srcAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { abi, address } = PriceFeedAbi[this.network];
                const contract = new this.web3Provider.eth.Contract(abi, address);
                const result = yield contract.methods
                    .getBestPrice(srcToken, destToken, srcAmount)
                    .call();
                const amount = new bignumber_js_1.default(result.rate).toFixed();
                const bestRoute = _(result.distribution)
                    .keys()
                    .filter((k) => _.isNaN(Number(k)))
                    .reduce((acc, exchange) => {
                    const percent = new bignumber_js_1.default(result.distribution[exchange]);
                    const _destAmount = percent.times(amount).dividedBy(100).toFixed(0);
                    const _srcAmount = percent
                        .times(new bignumber_js_1.default(srcAmount))
                        .dividedBy(100)
                        .toFixed(0);
                    acc.push({
                        destAmount: _destAmount,
                        srcAmount: _srcAmount,
                        percent: percent.toFixed(0),
                        exchange,
                    });
                    return acc;
                }, []);
                return { amount, bestRoute };
            }
            catch (error) {
                return { message: new Error(error).message };
            }
        });
    }
}
exports.ParaswapFeed = ParaswapFeed;
//# sourceMappingURL=paraswap-feed.js.map